import React from 'react';
import cn from 'clsx';
import {
  SelectionGroup as FrontonSelectionGroup,
  SelectionGroupItem,
  SelectionGroupProps as FrontonSelectionGroupProps,
} from 'fronton-react';
import { SelectionGroupValue as FrontonSelectionGroupValue } from 'fronton-react/selection-group/types';
import { css } from 'linaria';
import { createElementKey } from 'utils';
import { Swiper, SwiperSlide } from '../swiper';

export type SelectionGroupOption = {
  text: string;
  value: string;
};

export type SelectionGroupValue = FrontonSelectionGroupValue;

type SelectionGroupProps = {
  optionList: SelectionGroupOption[];
  selectionGroupItemClassName?: string;
  noSwipingWidth?: 1024 | 768;
} & FrontonSelectionGroupProps;

const selectionGroup = css`
  width: 100%;
`;

const swiper = css`
  && {
    @media (--only-largeDesktop) {
      margin: 0;
    }

    @media (--only-desktop) {
      width: auto;
      padding-right: calc((100vw - 940px) / 2);
      padding-left: calc((100vw - 940px) / 2);
      margin-right: calc((-100vw + 940px) / 2);
      margin-left: calc((-100vw + 940px) / 2);
    }
  }
`;

const swiperDesktopNoSwiping = css`
  && {
    @media (--from-desktop) {
      width: 100%;
      padding: 0;
      margin: 0;

      .swiper-wrapper {
        flex-wrap: wrap;
      }

      .swiper-slide {
        height: auto;
      }
    }
  }
`;

const swiperTabletNoSwiping = css`
  && {
    @media (--from-tablet) {
      width: 100%;
      padding: 0;
      margin: 0;

      .swiper-wrapper {
        flex-wrap: wrap;
      }

      .swiper-slide {
        height: auto;
      }
    }
  }
`;

const NO_SWIPING_MAP = {
  768: swiperTabletNoSwiping,
  1024: swiperDesktopNoSwiping,
}

const swiperItem = css`
  && {
    width: auto;
  }
`;

const noSwipingItem = css`
  && {
    &:first-of-type {
      button {
        margin-left: 0;
      }
    }

    &:last-child {
      button {
        margin-right: 0;
      }
    }
  }
`;

export const SelectionGroup: React.FC<SelectionGroupProps> = ({
  className,
  optionList,
  size = 'l',
  noSwipingWidth,
  selectionGroupItemClassName,
  ...rest
}) => (
  <FrontonSelectionGroup className={cn(className, selectionGroup)} size={size} {...rest}>
    <Swiper
      centeredSlides
      breakpoints={
        noSwipingWidth
          ? {
            [noSwipingWidth]: {
              noSwiping: true,
              noSwipingSelector: '.swiper',
              centeredSlides: false,
            },
          }
          : {}
      }
      centeredSlidesBounds
      className={cn(swiper, noSwipingWidth && NO_SWIPING_MAP[noSwipingWidth])}
      slidesPerView="auto"
      slideToClickedSlide
      watchOverflow>
      {optionList.map(({ text, value }: SelectionGroupOption, index: number) => (
        <SwiperSlide
          className={cn(swiperItem, { [noSwipingItem]: !noSwipingWidth })}
          key={createElementKey('selection-group-item', index)}
        >
          <SelectionGroupItem className={selectionGroupItemClassName} value={value}>{text}</SelectionGroupItem>
        </SwiperSlide>
      ))}
    </Swiper>
  </FrontonSelectionGroup>
);
